<template>
  <NoteSection
    label="Anticoagulants"
    required
    :highlight-required="isSectionIncomplete"
    :form-validated="formValidated"
  >
    <help-icon
      title="Is the Patient on Therapeutic Anticoagulation?"
      body="<p>This is a reminder to check whether the patient is currently receiving anticoagulant medications,
        as these can cause significant post-debridement hemorrhage.</p>

            <p><b>Contraindications to debridement include therapeutic anticoagulants such as:</b></p>
            <ul>
              <li>Coumadin (warfarin)</li>
              <li>Weight-based Lovenox</li>
              <li>Eliquis (apaxiban)</li>
              <li>Pradaxa (dabigatran)</li>
              <li>Xarelto (rivaroxaban)</li>
              <li>Savaysa (edoxaban)</li>
              <li>Plavix (clopidogrel)</li>
            </ul>
            <p>DVT prophylaxis doses of Heparin (20 mg sq BID) and Lovenox 40 mg sq daily are not contraindications to debridement.</p>
            <p><b>If the patient IS on therapeutic anticoagulation:</b></p>
            <p>After obtaining approval from the patient’s primary physician, you may:
              <ol>
                <li>Discontinue the anticoagulant.</li>
                <li>Start Lovenox 1 mg/(kg of the patient’s body weight) BID for one week.</li>
              </ol>
            </p>
            <p>Ensure the INR is below 1.2. Then hold the Lovenox the night before and the morning of debridement. Restart Lovenox the evening after debridement.</p>
            <p>You may repeat this process until the wound no longer needs debridement.</p>"
    ></help-icon>
    <radio-buttons
      v-model="therapeutic_anticoagulant"
      :items="query"
      label="Is patient on therapeutic anticoagulant?"
      class="col-sm-12"
      hide-details
      required
      row
    ></radio-buttons>
  </NoteSection>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: [Boolean, Number],
      default: null,
    },
    formValidated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      therapeutic_anticoagulant: this.value,
    }
  },
  computed: {
    ...mapGetters('baseData', ['query']),

    // Checks if the radio selection has not been made yet
    isSectionIncomplete() {
      return this.therapeutic_anticoagulant === null || this.therapeutic_anticoagulant === undefined
    },
  },
  watch: {
    therapeutic_anticoagulant(newValue) {
      this.$emit('input', newValue)
    },
  },
  methods: {
  },
}
</script>
